var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 70,
    viewBox: "0 0 192 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2114_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9069 29.9595V50.6985H87.7407V29.9595H79.5132V24.8094H102.134V29.9595H93.9069Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.213 46.5646V50.6985C118.584 50.8891 117.752 50.9872 116.713 50.9872C115.506 50.9872 114.536 50.814 113.815 50.4618C113.093 50.1096 112.567 49.5496 112.256 48.7759H112.111C111.534 49.5265 110.726 50.1096 109.698 50.5369C108.67 50.9583 107.55 51.172 106.343 51.172C105.137 51.172 104.028 50.941 103.024 50.4849C102.019 50.0288 101.222 49.3648 100.633 48.5103C100.039 47.65 99.7441 46.6454 99.7441 45.4849C99.7441 43.5276 100.368 42.0727 101.609 41.1142C102.856 40.1616 104.756 39.5149 107.319 39.1743C109.109 38.9318 110.322 38.6604 110.962 38.3602C111.603 38.06 111.921 37.6269 111.921 37.0727C111.921 36.3971 111.684 35.8717 111.216 35.4965C110.743 35.1212 110.062 34.9364 109.167 34.9364C108.347 34.9364 107.637 35.1674 107.048 35.6235C106.453 36.0854 106.037 36.7493 105.795 37.6154L100.431 36.963C100.841 35.1038 101.834 33.6431 103.405 32.5923C104.975 31.5415 106.932 31.0161 109.276 31.0161C112.082 31.0161 114.184 31.5819 115.587 32.7193C116.99 33.8567 117.689 35.4272 117.689 37.4306V45.5542C117.689 45.9872 117.758 46.2874 117.891 46.4433C118.024 46.5992 118.237 46.6801 118.526 46.6801C118.815 46.6801 119.046 46.6454 119.213 46.5704V46.5646ZM110.691 41.9572C110.137 42.1015 109.398 42.2459 108.48 42.3902C107.585 42.5346 106.886 42.829 106.378 43.2794C105.87 43.7239 105.616 44.3359 105.616 45.1096C105.616 45.8082 105.83 46.3683 106.251 46.7782C106.673 47.1881 107.25 47.396 107.972 47.396C108.572 47.396 109.178 47.2459 109.785 46.9399C110.391 46.6396 110.899 46.1777 111.309 45.56C111.719 44.9422 111.927 44.1743 111.927 43.2563V41.4433C111.661 41.6396 111.251 41.8071 110.697 41.9514L110.691 41.9572Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.778 35.3637C130.172 34.9075 129.421 34.6766 128.532 34.6766C127.683 34.6766 127.002 34.8498 126.482 35.202C125.963 35.5542 125.703 36.0449 125.703 36.6685C125.703 37.2459 125.957 37.6731 126.465 37.9387C126.973 38.2043 127.782 38.4353 128.896 38.6258L130.888 38.9145C132.291 39.157 133.486 39.4687 134.479 39.8556C135.472 40.2424 136.28 40.8429 136.91 41.6512C137.539 42.4595 137.851 43.5565 137.851 44.9306C137.851 46.9861 137.002 48.5392 135.31 49.59C133.619 50.6408 131.407 51.1662 128.676 51.1662C126.09 51.1662 123.948 50.6292 122.256 49.5553C120.564 48.4814 119.56 46.9861 119.248 45.075L124.687 44.4572C124.854 45.4734 125.293 46.2355 125.992 46.7436C126.69 47.2516 127.597 47.5057 128.711 47.5057C129.704 47.5057 130.495 47.2978 131.084 46.8879C131.679 46.478 131.973 45.9064 131.973 45.1847C131.973 44.6304 131.69 44.1916 131.119 43.8798C130.553 43.568 129.698 43.314 128.561 43.1177L126.384 42.7944C124.427 42.4826 122.862 41.9052 121.69 41.0738C120.518 40.2424 119.929 38.8798 119.929 36.9976C119.929 35.7389 120.316 34.665 121.09 33.7701C121.864 32.8752 122.903 32.1939 124.208 31.7205C125.512 31.247 126.939 31.0161 128.486 31.0161C130.83 31.0161 132.799 31.5242 134.398 32.5403C135.997 33.5565 136.95 34.948 137.262 36.7089L131.933 37.3267C131.765 36.4838 131.379 35.8255 130.772 35.3694L130.778 35.3637Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.645 50.6985H139.877V24.4514H145.645V38.8105L152.169 31.4837H158.624L151.592 38.8798L159.421 50.6985H152.787L147.746 42.7193L145.645 44.9306V50.6928V50.6985Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.053 44.896L165.131 50.6985H158.606L168.035 24.8094H176.262L185.691 50.6985H179.091L177.169 44.896H167.053ZM172.128 29.9595H171.984L168.537 40.4041H175.645L172.128 29.9595Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.309 24.4456V28.9433H185.546V24.4456H191.309ZM191.309 31.478V50.6928H185.546V31.478H191.309Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1694 41.6282L37.0366 39.8037C37.0193 39.5727 36.9327 39.3591 36.7884 39.1801L35.3219 37.4018C34.7965 36.7667 35.1256 35.8025 35.9339 35.6178L38.4396 35.052C38.6186 35.0115 38.7861 34.9249 38.9246 34.8037L39.7156 34.1108C40.3161 33.5854 41.263 33.851 41.4997 34.6189L41.9962 36.2298C42.0828 36.5069 42.2791 36.7436 42.5332 36.8822L43.405 37.3441C44.0228 37.6732 44.1844 38.4873 43.7399 39.0242L43.226 39.6478C42.9835 39.9423 42.9085 40.3406 43.0297 40.7044L43.2087 41.2413C43.5147 42.1478 42.5967 42.9908 41.7191 42.6097L40.8011 42.2113C40.5644 42.1074 40.293 42.0901 40.0447 42.1651L38.5898 42.6039C37.9142 42.806 37.2214 42.3326 37.1694 41.6282Z",
    stroke: "url(#paint0_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3854 43.4123L35.166 40.4561C35.1371 40.0866 34.9986 39.7344 34.7618 39.4515L32.3831 36.5705C31.5344 35.5427 32.0713 33.9781 33.3704 33.6836L37.4235 32.7714C37.718 32.7079 37.9836 32.5693 38.2087 32.373L39.4905 31.2529C40.4662 30.3984 42.002 30.8314 42.3831 32.0728L43.1914 34.6825C43.33 35.1386 43.6475 35.5139 44.0632 35.739L45.4778 36.4896C46.4824 37.0208 46.7422 38.3372 46.0205 39.2148L45.1891 40.2252C44.7965 40.7044 44.6752 41.3511 44.8715 41.94L45.166 42.806C45.6625 44.2783 44.1787 45.6409 42.7526 45.0231L41.2688 44.3765C40.8819 44.209 40.4431 44.1802 40.039 44.3014L37.6776 45.0116C36.5806 45.3407 35.4605 44.5728 35.3739 43.4296L35.3854 43.4123Z",
    stroke: "url(#paint1_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5958 45.1905L33.2955 41.1028C33.2551 40.5947 33.0646 40.1039 32.7355 39.7113L29.4503 35.7275C28.2782 34.3014 29.0173 32.142 30.8186 31.7379L36.4249 30.4734C36.829 30.3811 37.2043 30.1905 37.5103 29.9192L39.2828 28.3661C40.6339 27.1824 42.7528 27.7829 43.284 29.4977L44.3983 33.1062C44.5946 33.7356 45.0276 34.2552 45.605 34.567L47.5623 35.6005C48.948 36.3337 49.3117 38.1582 48.3129 39.3649L47.1639 40.7564C46.6212 41.4145 46.4537 42.3095 46.7251 43.1236L47.1293 44.3245C47.8163 46.3568 45.7667 48.239 43.7979 47.3845L41.7424 46.4954C41.2055 46.2644 40.605 46.2298 40.045 46.3972L36.7828 47.373C35.2644 47.8291 33.717 46.761 33.6015 45.1848L33.5958 45.1905Z",
    stroke: "url(#paint2_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8058 46.9746L31.419 41.7552C31.3728 41.1028 31.1187 40.4792 30.703 39.9769L26.5056 34.8845C25.0044 33.0658 25.9513 30.306 28.2492 29.7864L35.4028 28.1755C35.9167 28.0601 36.3959 27.8176 36.7943 27.4711L39.0518 25.4908C40.7723 23.9838 43.4802 24.746 44.1557 26.9342L45.576 31.5416C45.8243 32.3441 46.3786 33.0081 47.1176 33.4007L49.6176 34.7229C51.3843 35.6582 51.852 37.985 50.576 39.5323L49.1095 41.3106C48.4109 42.1536 48.203 43.2968 48.5495 44.3303L49.0633 45.8661C49.9351 48.4642 47.3197 50.8661 44.8081 49.7748L42.1869 48.6374C41.4998 48.343 40.7319 48.2968 40.0218 48.5104L35.8589 49.7575C33.9248 50.3407 31.9444 48.9781 31.7943 46.9631L31.8058 46.9746Z",
    stroke: "url(#paint3_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0216 48.7529L29.554 42.4019C29.4962 41.6109 29.1902 40.8545 28.6879 40.2367L23.584 34.0416C21.7595 31.8303 22.9085 28.47 25.7087 27.8407L34.4154 25.8834C35.039 25.7448 35.6221 25.4446 36.1071 25.0231L38.8554 22.6155C40.9512 20.7795 44.2422 21.709 45.0678 24.3764L46.7999 29.9827C47.1002 30.9584 47.7757 31.7725 48.6764 32.246L51.7133 33.8568C53.8669 35 54.4327 37.8291 52.8796 39.7055L51.0898 41.8707C50.241 42.8984 49.987 44.2841 50.4085 45.5485L51.0378 47.4134C52.1002 50.5716 48.9189 53.4989 45.8588 52.1709L42.6718 50.7852C41.8403 50.4215 40.905 50.3695 40.0332 50.6293L34.9639 52.1478C32.6082 52.8522 30.2006 51.2009 30.0216 48.7471V48.7529Z",
    stroke: "url(#paint4_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2318 50.5369L27.6776 43.0543C27.6083 42.1189 27.2503 41.2298 26.6556 40.5081L20.6452 33.2102C18.4974 30.6005 19.8542 26.6455 23.1452 25.9065L33.4051 23.597C34.1441 23.4296 34.8254 23.0831 35.397 22.5866L38.636 19.7517C41.1071 17.5866 44.987 18.6894 45.957 21.8245L47.9951 28.4296C48.3473 29.5785 49.1441 30.5369 50.2064 31.097L53.7861 32.9908C56.3208 34.336 56.9847 37.6674 55.1602 39.8845L53.0529 42.4365C52.054 43.6432 51.7538 45.2829 52.2503 46.7667L52.9893 48.9665C54.2422 52.6905 50.4893 56.1316 46.8866 54.5727L43.1279 52.9446C42.1464 52.5173 41.0436 52.4538 40.0217 52.7598L34.0517 54.5497C31.2746 55.3811 28.4397 53.4353 28.2261 50.5427L28.2318 50.5369Z",
    stroke: "url(#paint5_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.442 52.3152L25.8012 43.7067C25.7203 42.6328 25.3104 41.6051 24.6233 40.7737L17.7007 32.373C15.2296 29.3707 16.7885 24.8152 20.5818 23.9607L32.3889 21.3048C33.2377 21.1143 34.0286 20.7101 34.6811 20.1386L38.4109 16.8707C41.2515 14.3822 45.7203 15.6466 46.8346 19.2552L49.1845 26.8591C49.5945 28.1813 50.5067 29.284 51.725 29.9307L55.8474 32.1131C58.7688 33.6605 59.531 37.5 57.4293 40.0462L55.0044 42.985C53.8554 44.3764 53.509 46.2644 54.0864 47.9734L54.9409 50.5023C56.3843 54.7864 52.0656 58.7529 47.9201 56.9573L43.5956 55.0808C42.464 54.5901 41.1995 54.515 40.0217 54.8672L33.151 56.9284C29.9582 57.8868 26.6961 55.6409 26.4478 52.3152H26.442Z",
    stroke: "url(#paint6_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6579 54.0993L23.9362 44.3591C23.8438 43.1409 23.3819 41.9804 22.6025 41.0393L14.7734 31.5358C11.9731 28.1409 13.7399 22.985 18.0355 22.0208L31.3958 19.0127C32.3542 18.7991 33.2491 18.343 33.9882 17.6963L38.2087 14.0012C41.4246 11.1836 46.4766 12.6155 47.741 16.6975L50.3969 25.3002C50.8588 26.7956 51.8923 28.0427 53.2722 28.776L57.9316 31.2471C61.2341 32.9965 62.1002 37.3384 59.7214 40.2194L56.9789 43.545C55.6798 45.1213 55.2872 47.2517 55.9397 49.1859L56.9039 52.0497C58.5378 56.8996 53.6533 61.3857 48.9593 59.3476L44.069 57.2229C42.793 56.6686 41.3554 56.582 40.0216 56.9862L32.2503 59.3187C28.636 60.4042 24.9466 57.8638 24.6637 54.0993H24.6579Z",
    stroke: "url(#paint7_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8684 55.8776L22.0601 45.0058C21.9619 43.649 21.4423 42.3557 20.5762 41.2991L11.8349 30.6928C8.71135 26.9053 10.6802 21.1547 15.4723 20.0751L30.3799 16.7206C31.4538 16.4781 32.4469 15.9758 33.2726 15.2483L37.9839 11.1259C41.5751 7.97922 47.216 9.57853 48.619 14.1397L51.5809 23.7356C52.0947 25.4042 53.2495 26.7956 54.791 27.6155L59.9931 30.3695C63.6825 32.321 64.6467 37.1651 61.9908 40.3868L58.9307 44.0935C57.4816 45.8487 57.0428 48.2333 57.7702 50.3868L58.8441 53.5797C60.6629 58.9896 55.2125 64.0012 49.9758 61.7263L44.5139 59.3591C43.0878 58.7413 41.4885 58.6432 39.9989 59.0935L31.321 61.6975C27.2853 62.9099 23.1686 60.0751 22.8568 55.8718L22.8684 55.8776Z",
    stroke: "url(#paint8_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.078 57.6617L20.1888 45.6582C20.0791 44.157 19.5018 42.7309 18.5491 41.5704L8.90131 29.8614C5.45442 25.6755 7.6311 19.3302 12.9198 18.1351L29.3805 14.4284C30.5641 14.1628 31.6611 13.6028 32.5791 12.806L37.7754 8.25056C41.742 4.78059 47.966 6.54156 49.5191 11.5762L52.7928 22.1709C53.3586 24.0127 54.6346 25.5485 56.3378 26.455L62.0826 29.4977C66.153 31.657 67.2212 37.0034 64.2881 40.5543L60.9106 44.6478C59.3112 46.5878 58.8263 49.2148 59.6288 51.5993L60.8182 55.127C62.8274 61.097 56.8112 66.6282 51.026 64.1224L44.9983 61.5069C43.4221 60.8256 41.6554 60.7217 40.0156 61.2125L30.4371 64.0878C25.9856 65.4215 21.436 62.2979 21.0895 57.6559L21.078 57.6617Z",
    stroke: "url(#paint9_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2942 59.4399L18.3185 46.3048C18.1972 44.6651 17.5679 43.1005 16.5229 41.8302L5.96284 29.0185C2.19263 24.4399 4.57138 17.4942 10.3566 16.1894L28.3705 12.1363C29.6638 11.8418 30.8705 11.2356 31.8693 10.358L37.5564 5.37528C41.8924 1.5762 48.7053 3.50461 50.4086 9.01269L53.9882 20.6062C54.6118 22.6212 56.0033 24.3072 57.8681 25.2887L64.1557 28.6201C68.6072 30.9815 69.7792 36.8302 66.5691 40.7217L62.8739 45.2021C61.1245 47.3268 60.5933 50.2021 61.4709 52.806L62.77 56.6686C64.9698 63.2044 58.382 69.2552 52.0598 66.5127L45.4663 63.649C43.7458 62.9041 41.8116 62.7887 40.0102 63.3256L29.531 66.4723C24.658 67.933 19.6811 64.5092 19.3058 59.4342L19.2942 59.4399Z",
    stroke: "url(#paint10_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5043 61.224L16.4477 46.9573C16.3149 45.1732 15.6336 43.4758 14.4962 42.0959L3.02966 28.1813C-1.06965 23.2102 1.51695 15.664 7.80448 14.2494L27.3657 9.84412C28.7745 9.52657 30.0793 8.86259 31.1648 7.91571L37.3426 2.50578C42.0539 -1.62239 49.45 0.473449 51.2976 6.46075L55.189 19.0531C55.8645 21.2413 57.3772 23.0716 59.4038 24.1397L66.2283 27.7541C71.0666 30.3176 72.331 36.6744 68.8495 40.8949L64.8368 45.7621C62.9373 48.0658 62.3599 51.1894 63.3126 54.0243L64.7213 58.216C67.1116 65.3118 59.9581 71.888 53.0874 68.903L45.9223 65.7968C44.0516 64.9827 41.95 64.8614 39.9985 65.4446L28.6128 68.8568C23.3183 70.4446 17.9142 66.7263 17.5043 61.2125V61.224Z",
    stroke: "url(#paint11_linear_2114_448)",
    strokeWidth: 0.715935,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2114_448",
    x1: 34.7098,
    y1: 38.2737,
    x2: 44.3519,
    y2: 38.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2114_448",
    x1: 31.6152,
    y1: 37.9735,
    x2: 46.7942,
    y2: 37.9735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2114_448",
    x1: 28.5207,
    y1: 37.679,
    x2: 49.2309,
    y2: 37.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2114_448",
    x1: 25.4317,
    y1: 37.3788,
    x2: 51.6672,
    y2: 37.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2114_448",
    x1: 22.3369,
    y1: 37.0843,
    x2: 54.1094,
    y2: 37.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2114_448",
    x1: 19.248,
    y1: 36.7841,
    x2: 56.5459,
    y2: 36.7841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2114_448",
    x1: 16.1534,
    y1: 36.4896,
    x2: 58.9882,
    y2: 36.4896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2114_448",
    x1: 13.0586,
    y1: 36.1894,
    x2: 61.4246,
    y2: 36.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2114_448",
    x1: 9.97001,
    y1: 35.8949,
    x2: 63.8672,
    y2: 35.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2114_448",
    x1: 6.87475,
    y1: 35.5947,
    x2: 66.3032,
    y2: 35.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2114_448",
    x1: 3.78616,
    y1: 35.2944,
    x2: 68.7457,
    y2: 35.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2114_448",
    x1: 0.691319,
    y1: 35,
    x2: 71.1821,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2114_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.618,
    height: 70,
    fill: "white",
    transform: "translate(0.690918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogo);
export default __webpack_public_path__ + "static/media/img-logo.349c4445a0bd4e2392440db00e015792.svg";
export { ForwardRef as ReactComponent };